import { SourceType } from '../webrtc/agent/interfaces';
import getResponseForContentType from './getResponseForContentType';
import { HttpRequest, HttpResponse } from './interfaces';
import logger from '../log';
const log = logger.getLogger(__filename);

export const iteratorToMap = <K, V>(i: IterableIterator<[K, V]>): Map<K, V> => {
  return Array.from(i).reduce((acc, [key, value]: [K, V]) => {
    acc.set(key, value);
    return acc;
  }, new Map<K, V>());
};
export const mapToObject = <T>(map: Map<string, T>): Record<string, T> => {
  const obj: Record<string, T> = {};
  map.forEach((value, key) => {
    log.debug(`Adding header: "${key}" : "${value}"`);
    obj[key] = value;
  });
  return obj;
};

export default async function fetchRequest(
  request: HttpRequest
): Promise<HttpResponse> {
  const { url, modifiedUrl, method, credentials } = request;
  // if there is a modifiedUrl, us it.
  let signal = undefined;
  if (request.timeout > 0) {
    const controller = new AbortController();
    signal = controller.signal;
    setTimeout(() => controller.abort(), request.timeout);
  }
  const resp = await fetch(modifiedUrl || url, {
    method,
    headers: mapToObject(request.headers),
    credentials,
    signal
  });
  const data = await getResponseForContentType(resp, request.responseType);

  // DEAL with Transfer Records
  const timer = request.timer;
  timer.stop();
  const response = {
    body: data,
    headers: iteratorToMap(resp.headers.entries()),
    request,
    status: resp.status,
    statusText: resp.statusText,
    timer,
    sourceType: SourceType.INGEST
  };
  return response;
}
